import React from 'react'
import { Button, Header, List, Icon, Form,label, Input,  Modal } from 'semantic-ui-react'

const ModalComentario = ({showModal, closeModal}) => (
  <Modal open={showModal}   size='tiny'>
    <Header icon="money bill alternate outline" content="Metodos de Pago" />
    <Modal.Content>
       <Header as='h3' color="blue">Datos Bancarios para deposito o transferencia electrónica</Header>
    
    <List celled>
    <List.Item>
      <List.Content>
        <List.Header >Beneficiario</List.Header>
        Quality Academics
      </List.Content>
    </List.Item>
    
    <List.Item>
      <List.Content>
        <List.Header>Banco</List.Header>
        Santander
      </List.Content>
    </List.Item>
    
    
    <List.Item>
      <List.Content>
        <List.Header>Cuenta</List.Header>
        657689432543
      </List.Content>
    </List.Item>
    
    <List.Item>
      <List.Content>
        <List.Header>CLABE</List.Header>
        234365768943254356
      </List.Content>
    </List.Item>
    
    
    <List.Item>
      <List.Content>
        <List.Header>Concepto de pago o referencia</List.Header>
        ALU123435
      </List.Content>
    </List.Item>
    
    <List.Item>
      <List.Content>
        <List.Header>Enviar copia de pago o transferencia a</List.Header>
        pagos@qualityacademics.com
      </List.Content>
    </List.Item>
    </List>
    
    
    </Modal.Content>
    <Modal.Actions>
    
      <Button   color='red' onClick={closeModal}  >
        <Icon name='remove' /> Cerrar
      </Button>
       
    </Modal.Actions>
  </Modal>
)

export default ModalComentario;